import { FormlyFieldConfig } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";

export class TranslateExtension {
  constructor(private translate: TranslateService) {}
  prePopulate(field: FormlyFieldConfig) {
    const to = field.templateOptions || {};
    if (!to.translate || to._translated) {
      return;
    }

    to._translated = true;
    field.expressionProperties = {
      ...(field.expressionProperties || {}),
      "templateOptions.label": this.translate.stream(to.label),
    };
    //
    field.expressionProperties = {
      ...(field.expressionProperties || {}),
      "templateOptions.placeholder": this.translate.stream(to.placeholder),

    };
    //  field.expressionProperties = {
    //     ...(field.expressionProperties || {}),
    //   "templateOptions.addText": this.translate.stream(to.addText),

    //    };
  }
}

export function registerTranslateExtension(translate: TranslateService) {
  return {
    validationMessages: [
      {
        name: "required",
        message() {
          return translate.stream("FORM.VALIDATION.REQUIRED");
        }
      }
    ],
    extensions: [
      {
        name: "translate",
        extension: new TranslateExtension(translate)
      }
    ]
  };
}

/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
